import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import swal from 'sweetalert';

import axios from '../../services/MyAxios';

import PaymentMethodChannelForm from './PaymentMethodChannelForm';

import Card from 'crm/elements/common/Card';

function PaymentMethodChannelCreate() {
    const [errors, setErrors] = useState([]);
    const history = useHistory();
    const url = '/crea/api/payment_method_channel';

    const handleCreatePaymentMethodChannel = (newPaymentMethodChannel) => {
        const data = new FormData();
        data.append('name', newPaymentMethodChannel.name);
        data.append('payment_method_id', newPaymentMethodChannel.payment_method_id);
        data.append('logo', newPaymentMethodChannel.logo);
        data.append('order', newPaymentMethodChannel.order);

        axios
            .post(url, data, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then(() => {
                swal({
                    title: 'Success',
                    text: 'Payment Method channel created correctly',
                    icon: 'success',
                }).then(() => {
                    history.push('/payment_method_channels');
                });
            })
            .catch((error) => {
                setErrors(error.response.data.errors);
            });
    };

    return (
        <Card title="Create new payment method channel">
            <PaymentMethodChannelForm action={handleCreatePaymentMethodChannel} errors={errors} />
        </Card>
    );
}

export default PaymentMethodChannelCreate;
